module.exports = __webpack_public_path__ + "media/images/icon-arrow-rotated-yellow-380fdbf232c7b8b175bbc2012d8a657c.svg";